import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { BaseRequestPolicy } from "./requestPolicy";
/**
 * Creates a policy that assigns a unique request id to outgoing requests.
 * @param requestIdHeaderName - The name of the header to use when assigning the unique id to the request.
 */

export function generateClientRequestIdPolicy() {
  var requestIdHeaderName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "x-ms-client-request-id";
  return {
    create: function create(nextPolicy, options) {
      return new GenerateClientRequestIdPolicy(nextPolicy, options, requestIdHeaderName);
    }
  };
}
export var GenerateClientRequestIdPolicy = /*#__PURE__*/function (_BaseRequestPolicy) {
  _inherits(GenerateClientRequestIdPolicy, _BaseRequestPolicy);

  function GenerateClientRequestIdPolicy(nextPolicy, options, _requestIdHeaderName) {
    var _this;

    _classCallCheck(this, GenerateClientRequestIdPolicy);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GenerateClientRequestIdPolicy).call(this, nextPolicy, options));
    _this._requestIdHeaderName = _requestIdHeaderName;
    return _this;
  }

  _createClass(GenerateClientRequestIdPolicy, [{
    key: "sendRequest",
    value: function sendRequest(request) {
      if (!request.headers.contains(this._requestIdHeaderName)) {
        request.headers.set(this._requestIdHeaderName, request.requestId);
      }

      return this._nextPolicy.sendRequest(request);
    }
  }]);

  return GenerateClientRequestIdPolicy;
}(BaseRequestPolicy);